import { styled, Grid as MuiGrid } from "@mui/material";
import { darkDeYork } from "shared/assets/colors";

const PREFIX = "MissingDebtorsActionsStyles";
export const classes = {
  importButton: `${PREFIX}-importButton`,
  disabledButton: `${PREFIX}-disabledButton`,
};

export const Grid = styled(MuiGrid)(() => ({
  [`& .${classes.importButton}`]: {
    backgroundColor: darkDeYork,
  },
  [`& .${classes.disabledButton}`]: {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
  },
}));
